<template>
	<div class="ga-container d-block pb-5">
		<div id="success-page"></div>
    <div class="row justify-content-center">
      <div class="col-xl-8 col-12 mb-5">
        <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey mb-5 p-4">
          <div v-if="is_load" class="w-100 my-5 text-center">
            <loader />
          </div>
          <template v-else>
            <div class="p-3 d-block" v-if="error != ''">
              <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
                <div class="row grid-slim-row">
                  <div class="col-12 text-center">
                    <p class="mb-0 body-3-1">{{error}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="container position-relative text-center" :class="{'py-3':tx.status != 'WAITING_CONFIRMATION','px-0':tx.status == 'WAITING_CONFIRMATION'}">
  
              <!-- Payment Complete or Payment Pending CC Xendit -->
              <BookingResult v-if="showBookingResult" :data="tx" @geTxDetail="geTxDetail()" @getTXDetailPdf="getTXDetailPdf()" />
  
              <!-- Payment Direct-->
              <template v-else-if="(tx.payment_details.bank_name == 'DIRECT_PAYMENT' || (tx.payment_details.bank_name == 'WISE' && tx.payment_details.payment_method == 'BANK_TRANSFER')) && tx.status == 'WAITING_PAYMENT_CONFIRMATION'">
                <DirectPayment :tx="tx"></DirectPayment>
              </template>
  
              <!-- WAITING PAYMENT CONFIRMATION -->
              <template v-if="tx.status == 'WAITING_PAYMENT_CONFIRMATION'">
                 <!-- Payment Virtual Account-->
                 <template v-if="(payment_method == 'QRIS' || payment_method == 'VIRTUAL_ACCOUNT') && (tx.payment_details.bank_name == 'BPD_BALI' || tx.payment_details.bank_name == 'JOKUL_DOKU' || tx.payment_details.bank_name == 'DOKU' || tx.payment_details.bank_name == 'XENDIT' || tx.payment_details.bank_name == 'XENDIT_INTERNATIONAL' || tx.payment_details.bank_name == 'MIDTRANS' || tx.payment_details.bank_name == 'IPAYMU' || tx.payment_details.bank_name == 'CASHLEZ')">
                   <b-row class="justify-content-center" no-gutters>
                     <b-col cols="6" class="fit-to-screen bg-white" style="padding-bottom: 60px">
                       <qris-form v-if="payment_method == 'QRIS'" :data="tx" />
                       <VirtualAccountForm v-if="payment_method == 'VIRTUAL_ACCOUNT' && tx.payment_details.bank_name == 'BPD_BALI'" :data="tx.payment_details" type="hotel" :tx_date="tx.created_at"></VirtualAccountForm>
                       <div class="text-left">
                         <VirtualAccount v-if="payment_method == 'VIRTUAL_ACCOUNT' && (tx.payment_details.bank_name == 'JOKUL_DOKU' || tx.payment_details.bank_name == 'DOKU' || tx.payment_details.bank_name == 'XENDIT' || tx.payment_details.bank_name == 'XENDIT_INTERNATIONAL' || tx.payment_details.bank_name == 'MIDTRANS' || tx.payment_details.bank_name == 'IPAYMU' || tx.payment_details.bank_name == 'CASHLEZ')" :data="tx" module_page="HOTEL_BOOKING_ENGINE" :customer_detail="tx.customer_details"></VirtualAccount>
                       </div>
                       <div class="text-center w-100 my-3">
                         <div class="bg-white mb-4 mt-3">
                           <div class="px-4 py-3 text-center">
                             <p class="body-2-4 mb-3">
                               {{$t("hotel.waiting.already-made-a-payment")}}
                             </p>
                             <div @click="checkPaymentStatus" class="rounded-6 px-4 py-3 text-center mb-2" :class="{'bg-orange cursor-pointer': !btn_is_load, 'bg-orange-disabled cursor-disable' : btn_is_load}">
                               <pulse-loader :loading="btn_is_load" v-if="btn_is_load"></pulse-loader>
                               <p class="text-white body-15 mb-0 ls-1-25" v-else>{{$t("hotel.waiting.check-payment-status")}}</p>
                             </div>
                             <p v-if="error_payment" class="body-2-4 mb-3 text-danger">
                               {{$t("hotel.waiting.payment-still-not-processed")}}
                             </p>
                           </div>
                         </div>
                       </div>
                     </b-col>
                   </b-row>
                 </template>
  
  
                 <!-- E-WALLET -->
                  <template v-else-if="tx.payment_details.bank_name == 'XENDIT_INTERNATIONAL' && tx.payment_details.payment_channel == 'E_WALLET'">
                    <b-row class="justify-content-center" no-gutters>
                      <b-col cols="6" class="fit-to-screen bg-white" style="padding-bottom: 60px">
                        <EWallet :data="tx" :customer_detail="tx.customer_details" />
                      </b-col>
                    </b-row>
                  </template>
                  
                  <div v-else-if="payment_method == 'CREDIT_CARD' && !(tx.payment_details.bank_name == 'XENDIT' || tx.payment_details.bank_name == 'XENDIT_INTERNATIONAL')" class="position-relative text-center">
                    <div class="bg-orange rounded-100 size-icon-in mx-auto">
                      <img src="../../../assets/img/icon/history-white.png" width="50" class="position-relative" style="top: 16px;left: -2px">
                    </div>
                    <div class="px-5">
                      <p class="mt-3 mb-3 heading-5-2 text-black">{{$t("hotel.waiting.payment-is-being-processed")}}</p>
                      <p class="body-2-4 text-black mb-0">{{$t("hotel.success.order-id")}}: {{tx.order_code}}</p>
                      <p class="body-2-4 text-black mb-3">{{$t("hotel.success.transaction-date")}}: {{formatDate(tx.created_at)}}</p>
                      <p class="body-2-2 text-black mb-0 text-16 w-80 mx-auto">{{$t("hotel.waiting.please-wait")}}</p>
                      <p class="body-2-2 text-black mb-0 text-16 w-80 mx-auto">{{$t("hotel.waiting.you-can-check-the-payment")}}</p>
                      <button type="button" class="button-secondary border text-white my-3 px-4" @click="reloadPage()">{{$t("hotel.waiting.check-payment-status")}}</button>
  
                      <p class="mb-0 mt-3 body-2-2 text-black text-16 w-80 mx-auto">{{$t("hotel.waiting.if-the-payment-status-has-not-changed")}}</p>
                      <a :href="'mailto:'+getMerchant().email+'?subject='+getMerchant().name+' - Waiting Payment Status&body=Hello! Please change my payment status with Order ID '+tx.order_code+', Transaction Date '+formatDate(tx.created_at)" target="_blank">
                        <p class="mb-0 mt-2 body-2-2 font-bold underline text-black text-16 d-table mx-auto">{{getMerchant().email}}</p>
                      </a>
                    </div>
                  </div>
  
               </template>
  
              <!-- Payment Cancelled -->
              <!-- <template v-else-if="tx.status == 'CANCELLED'">
                <div class="position-relative text-center pb-3 mt-4">
                  <div class="rounded-100 mx-auto">
                    <div class="bg-danger rounded-100 size-icon-in mx-auto">
                      <img src="../../../assets/img/icon/cancel.png" width="50" class="position-relative p-1" style="top: 16px;">
                    </div>
                  </div>
                  <p class="mt-3 mb-0 heading-5-2 text-black">{{$t("hotel.failed.reservation-failed")}}</p>
                  <p class="body-2-2 font-bold text-16 text-black mt-2 mb-0 w-50 mx-auto">{{$t("hotel.failed.sorry-an-error")}}</p>
                  <router-link :to="'/'+getMerchant().code+'/booking'">
                    <button type="button" class="button-secondary border text-white px-4 mt-4">{{$t("hotel.failed.retry")}}</button>
                  </router-link>
                </div>
              </template> -->
            </div>
          </template>
          <!-- <div class="snow" style="top: 50px;left: 100px;background-color: #cbcaca45"></div>
          <div class="snow" style="top: 200px;left: 520px;background-color: #cbcaca45;width: 12px;height: 12px"></div>
          <div class="snow" style="top: 256px;left: 55px;background-color: #cbcaca45;width: 12px;height: 12px"></div>
          <div class="snow" style="top: 500px;left: 75px;background-color: #cbcaca45"></div>
          <div class="snow" style="top: 428px;left: 600px;background-color: #cbcaca45;width: 12px;height: 12px"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import {post,get} from '@/services/index.js'
	import {formatCurrency} from '@/utils/index.js'
	import topNavbar from '@/components/hotel/be/desktop/navbar.vue';
  import {customFormatDateTime} from '@/utils/index.js';
	import {mapGetters} from 'vuex'
  import Flickity from 'vue-flickity';
  import QrisForm from '@/components/general/QrisForm';
  import VirtualAccountForm from '@/components/hotel/VirtualAccountForm';
  import VirtualAccountBank from '@/components/hotel/be/VirtualAccountBank';
  import VirtualAccount from '@/components/general/payment/VirtualAccount'
  import EWallet from '@/components/general/payment/EWallet'
  import DirectPayment from '@/components/hotel/be/DirectPayment'
  import CancelBooking from '@/components/hotel/be/CancelBooking'
	import headerStepOrder from '@/components/hotel/be/desktop/headerStepOrder.vue';
	import ProductBookingResult from '@/components/hotel/be/additionalService/ProductBookingResult';
	import BookingResult from '../../../components/hotel/be/BookingResult';

	export default{
		components: {
			topNavbar,
			Flickity,
			QrisForm,
			VirtualAccountForm,
			VirtualAccountBank,
			VirtualAccount,
			DirectPayment,
			CancelBooking,
			headerStepOrder,
			ProductBookingResult,
			BookingResult,
			EWallet
		},
		data(){
			return{
				is_load: true,
				error: '',
				tx:{},
				order_detail: false,
				order_step: 3,
				is_order_need_payment: false,
				merchant_area: '',
				flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
        payment_method: '',
        error_payment: false,
        btn_is_load: false,
        action_success:{
          show: false,
          message: '',
          timer: 0
        },
			}
		},
		computed:{
			tx_id(){
				return this.$route.params.tx_order_id
			},
			is_valid_special_request(){
        return (this.tx.special_request_details.length > 0 || this.tx.custom_check_in_time != '' || this.tx.custom_check_out_time != '') ? true : false
      },
      is_deposit_arrival(){
      	return this.tx.payments.total_payment - this.tx.payments.total_deposit > 0 ? true : false
      },
      is_valid_visitor(){
      	let display = false
      	if (this.tx.visitor_details.address != '' && this.tx.visitor_details.email != '' && this.tx.visitor_details.first_name != '' && this.tx.visitor_details.phone_number != '') {
      		display = true
      	}
      	return display
      },
      load_cart_step(){
      	let display = 0
      	if (this.tx.status == 'COMPLETE' || this.tx.status == 'NO_SHOW') {
      		display = 3
      	}else if(this.tx.status == 'WAITING_PAYMENT_CONFIRMATION') {
      		display = 'waiting'
      	}else if(this.tx.status == 'WAITING_PAYMENT_CONFIRMATION' && this.payment_method == 'CREDIT_CARD') {
      		display = 'being_processed'
      	}else if(this.tx.status == 'CANCELLED') {
      		display = 'failed'
      	}else if (this.tx.status == 'WAITING_CONFIRMATION'){
      		display = 'w_confirm'
      	}
      	return display
      },
      show_success(){
        return this.action_success.show
      },
      showBookingResult(){
        const transactionIsEmpty = this.$isEmpty(this.tx);
        // const paymentMethodIsEmpty = this.$isEmpty(this.payment_method);
        if(transactionIsEmpty) return false;

        if(this.tx.created_at === '*') return true;

        const { status : currentStatus, payment_details: { bank_name, payment_method, payment_channel } } = this.tx; 

        const validStatus = ['COMPLETE', 'NO_SHOW', 'WAITING_CONFIRMATION', 'CANCELLED']
        const isCurrentStatusValid = validStatus.some(status => status === currentStatus);
       
        const isStatusPendingPayment = currentStatus == 'WAITING_PAYMENT_CONFIRMATION';;
        const isPaymentCreditCard = this.payment_method == 'CREDIT_CARD'
        const isPaymentChannelXendit = bank_name == 'XENDIT' || bank_name== 'XENDIT_INTERNATIONAL'
        const isPaymentCCXendit =  isStatusPendingPayment && isPaymentCreditCard && isPaymentChannelXendit;

        const isPaymentPaypal = payment_method === 'PAYPAL' && bank_name === 'PAYPAL' &&  payment_channel === 'PAYPAL'

        return isCurrentStatusValid || isPaymentCCXendit || isPaymentPaypal;
      }
		},
		watch:{
			show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
		},
		mounted(){
			this.$postLog("PAYMENT_RESULT","","First Load",this.tx_id)
      this.loadMerchantArea()
			this.geTxDetail()
			document.getElementById('success-page').scrollIntoView({
        behavior: 'smooth'
      });
		},
		methods:{
			...mapGetters(['getMerchant']),
			formatCurrency(value){
        return formatCurrency(value);
      },
      checkPaymentStatus(){
      	this.error_payment = false
        this.btn_is_load = true
        this.geTxDetail()
      },
      roundUpIfXenditCC(data){
      	let isNumber = Number(data)
      	if(Object.keys(this.tx).length > 0 && this.tx.payment_details.bank_name == 'XENDIT' && this.tx.payment_details.payment_method == 'CREDIT_CARD'){
      		return Math.ceil(isNumber)
      	}else{
      		return isNumber
      	}
      },
      goToCustomButton(){
      	let tag_a = document.createElement('a')
    		tag_a.href = this.getMerchant().payment_result_custom_button_url
    		tag_a.target = '_blank'
    		tag_a.click()
    		tag_a.remove()
      },
			geTxDetail(){
				this.is_load = (this.btn_is_load) ? false : true
				this.error = ''
				this.total_room = 0
				let params = {
      		merchant_id : this.getMerchant().id,
				}
        const routeQuery = this.$route.query;
        if(this.$isNotEmptyV2(routeQuery) && this.$isNotEmptyV2(routeQuery.tx_sk)){
          params.tx_sk = routeQuery.tx_sk
        }
				get("CORE_HOTEL","tx-detail/"+this.tx_id,params).then(response=>{
					let res = response.data
					if(res.success){
						this.tx = res.data

						this.payment_method = (res.data.payment_details != null) ? res.data.payment_details.payment_method : ''
						if(typeof this.payment_method == 'object') this.payment_method = this.payment_method.payment_method
						
						for(let room of this.tx.transaction_details){
							this.total_room += room.qty
						}
						if(res.data.payments.total_deposit != '0'){
							this.is_order_need_payment = true
							
						}
						if(res.data.status == 'WAITING_PAYMENT_CONFIRMATION'){
							this.order_step = 3
						}
						if(res.data.status == 'COMPLETE' || res.data.status == 'CANCELLED'){
							this.order_step = res.data.payments.total_deposit != '0' ? 5 : 4
              this.$emit("update-step", 4);
						}
						if(res.data.status == 'WAITING_CONFIRMATION' || res.data.status == 'NO_SHOW'){
							this.order_step = res.data.payments.total_deposit != '0' ? 4 : 3
						}
						if(res.data.status == 'COMPLETE' || res.data.status == 'NO_SHOW' || (res.data.status == 'WAITING_CONFIRMATION' && res.data.payments.total_deposit == '0')){
							this.error_payment = false
						}else{
							if(res.data.payment_details.payment_method == 'QRIS'){
								this.error_payment = this.btn_is_load
							}
						}
            this.sendToMetaCAPI(res.data);
            this.$emit('sendTrackEvent', res.data);
						this.btn_is_load = false
					}else{
						this.error = res.message
					}
					this.is_load = false
				})
			},
      async sendToMetaCAPI(transactionDetail){
        const { status, meta_pixel_posting_date, payment_details } =  transactionDetail;

        const isStatusComplete = status === 'COMPLETE';
        const isRoutePaymentSuccess = this.$route.name === 'BePaymentResult';
        const isMetaReadyToPost = this.$isEmpty(meta_pixel_posting_date);
        
        if (isStatusComplete && isRoutePaymentSuccess && isMetaReadyToPost) {
          const postedDate = await this.postingDateIntegration("meta_pixel");
          if(postedDate){
            const params = {
              tx_order_id: this.tx_id,
              ...transactionDetail,
              payment_method_selected: payment_details ? payment_details.payment_method_name : null
            }

            this.$sendEventMetaConversionsAPI('Purchase', params);
          }
        }
      },
      async postingDateIntegration(type, status = null){
        try {
          let params = {posting_date_types: type}
          if(status) params.status = status
          
          const apiResponse = await post("CORE_HOTEL", `tx-detail/${this.tx_id}/posting-date`, params);
          
          return apiResponse.data.success;
        } catch (error) {
          console.log("Error postingDateIntegration : ", error.message)
        }
      },
			sendAnalytics(event){
				if(this.getMerchant().google_analytics_id != null){
          if(this.getMerchant().google_analytics_id != ''){
            this.$gtag('event',event, { method: 'Google' })
          }
        }
			},
			getTXDetailPdf(){
				this.is_load = true
				this.error = ''
				let params = {
      		merchant_id : this.getMerchant().id,
					export_to : 'pdf'
				}
        const routeQuery = this.$route.query;
        if(this.$isNotEmptyV2(routeQuery) && this.$isNotEmptyV2(routeQuery.tx_sk)){
          params.tx_sk = routeQuery.tx_sk
        }
				get("CORE_HOTEL","tx-detail/"+this.tx_id,params).then(response=>{
					let res = response.data
					if(res.success == false) {
						this.error = res.message
					}else{
						this.sendAnalytics('print_voucher')
						var file = new Blob([res], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
					}
					this.is_load = false
				})
			},
			downloadQris(url){
				window.open(url,'_blank')
			},
			loadMerchantArea(){
        get("CORE","user-location",{
          lat: this.getMerchant().lat,
          long: this.getMerchant().lng
        }).then(response=>{
          let location_type = response.data.data.address_components
            for(let i = 0; i < location_type.length;i++){
                if (location_type[i].types[0] == 'administrative_area_level_3') {
                    this.merchant_area = location_type[i].short_name;
                    break;
                }
            }
        })
      },
      formatDate(date) {
        return customFormatDateTime(date, null, 'ddd, DD MMM YYYY')
      },
			isToggle(){
				this.order_detail = !this.order_detail
			},
			reloadPage(){
				location.reload()
			},
			copyField(data,message){
				var value = data
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = message
        this.action_success.timer = 2
			},
			goToConfirmPayment(){
				this.$router.push(`/${this.getMerchant().code}/be/confirm-payment/${this.tx_id}`)
			}
		},
	}
</script>
<style scoped>
	.snow{
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/pages/hotel/be/BePaymentResultDesktop.vue